var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// x-date-picker.ts
import "@adornis/ass/style";
import DateTimeBehaviorSubject from "@adornis/base/rxjs-extension/reactives/luxon";
import "@adornis/chemistry/chemistry-lit-element";
import "@adornis/chemistry/controllers/chemistry-controller";
import { event } from "@adornis/chemistry/decorators/event";
import { css } from "@adornis/chemistry/directives/css";
import "@adornis/chemistry/elements/components/x-flex";
import "@adornis/chemistry/elements/components/x-icon";
import { FormField } from "@adornis/forms/form-field";
import { html } from "lit";
import { state } from "lit/decorators.js";
import { DateTime } from "luxon";
import { fromEvent, pairwise } from "rxjs";
import { takeUntil } from "rxjs/operators";
var DateTimeBehaviorController = class extends DateTimeBehaviorSubject {
  constructor(host, startValue) {
    super(startValue);
    (this.host = host).addController(this);
  }
  get propertyName() {
    if (!this._propertyName) {
      let propertyName = Object.keys(this.host).find((propertyKey) => this.host[propertyKey] === this);
      if (propertyName.startsWith("__"))
        propertyName = propertyName.replace(/^__/, "");
      this._propertyName = propertyName;
    }
    return this._propertyName;
  }
  hostConnected() {
    if (!this.subscription)
      this.subscription = this.pipe(pairwise()).subscribe(
        ([oldValue]) => this.host.requestUpdate(this.propertyName, oldValue)
      );
  }
  hostDisconnected() {
    if (this.subscription)
      this.subscription.unsubscribe();
    this.subscription = void 0;
  }
};
var ElementsDatePicker = class extends FormField {
  constructor() {
    super();
    this.styles = () => ({
      userSelect: "none",
      fontFamily: this.fontFamily,
      textAlign: "center",
      color: this.colors.on.white,
      "[monthnumber]": { borderRadius: "50%", height: "38px", width: "38px" },
      "[monthnumber]:hover": { background: this.colors.neutral_100 },
      "[blocked]": {
        opacity: "0.3",
        pointerEvents: "none"
      },
      "[out-of-month]": {
        color: this.colors.neutral_200,
        pointerEvents: "none",
        height: "38px",
        width: "38px"
      },
      "[selected]": { background: this.colors.accent, color: this.colors.on.accent, borderRadius: "50%" },
      "[highlighted]": { background: "rgba(0, 0, 0, 0.3)" },
      "[pointer]": { cursor: "pointer" }
    });
    this.date = new DateTimeBehaviorController(this, DateTime.now());
    this.value.next(DateTime.now());
  }
  connectedCallback() {
    super.connectedCallback();
    fromEvent(window, "keyup").pipe(takeUntil(this.disconnected)).subscribe((e) => {
      if (this.disabled)
        return;
      switch (e.code) {
        case "ArrowLeft":
          return this.date.minus({ months: 1 });
        case "ArrowRight":
          return this.date.plus({ months: 1 });
        case "ArrowUp":
          return this.date.minus({ years: 1 });
        case "ArrowDown":
          return this.date.plus({ years: 1 });
      }
    });
    this.value.pipe(takeUntil(this.disconnected)).subscribe((value) => this.date.next(value));
  }
  get weeklineData() {
    return ["M", "D", "M", "D", "F", "S", "S"];
  }
  getDateGridForMonth() {
    if (!this.date.value)
      throw new Error("date needs to exists on state to genereate the date-grid");
    const numBefore = this.getNumMonthBeginningSpacers();
    const numAfter = this.getNumMonthEndingSpacers();
    return [
      ...[...Array(numBefore)].map((_, i) => this.date.value.startOf("month").minus({ days: numBefore - i })),
      ...[...Array(this.date.value.daysInMonth)].map((x, i) => this.date.value.set({ day: i + 1 })),
      ...[...Array(numAfter)].map((_, i) => this.date.value.plus({ months: 1 }).set({ day: i + 1 }))
    ];
  }
  getNumMonthBeginningSpacers() {
    return this.date.value.startOf("month").weekday - 1;
  }
  getNumMonthEndingSpacers() {
    const calWeekDifference = 6 - Math.ceil(
      this.date.value.endOf("month").endOf("week").diff(this.date.value.startOf("month").startOf("week"), "weeks").weeks
    );
    return 7 - this.date.value.endOf("month").weekday + calWeekDifference * 7;
  }
  number(day) {
    return html` <x-text flex-none> ${day} </x-text> `;
  }
  weeklineEntry(day) {
    return html` <x-h4 ${css({ color: this.colors.accent })}> ${day} </x-h4> `;
  }
  header() {
    return html`
      <x-flex horizontal center crossaxis-center space="md" ${css({ userSelect: "none" })}>
        <x-flex horizontal crossaxis-center space-between flex space="sm">
          <x-icon
            ${css({ cursor: "pointer", color: this.colors.accent })}
            @click="${() => this.date.minus({ months: 1 })}"
          >
            chevron_left
          </x-icon>
          <x-text> ${this.date.getValue().monthLong} </x-text>
          <x-icon
            ${css({ cursor: "pointer", color: this.colors.accent })}
            @click="${() => this.date.plus({ months: 1 })}"
          >
            chevron_right
          </x-icon>
        </x-flex>
        <x-flex horizontal crossaxis-center space-between flex space="sm">
          <x-icon
            ${css({ cursor: "pointer", color: this.colors.accent })}
            @click="${() => this.date.minus({ years: 1 })}"
          >
            chevron_left
          </x-icon>
          <x-text> ${this.date.getValue().year} </x-text>
          <x-icon
            ${css({ cursor: "pointer", color: this.colors.accent })}
            @click="${() => this.date.plus({ years: 1 })}"
          >
            chevron_right
          </x-icon>
        </x-flex>
      </x-flex>
    `;
  }
};
__decorateClass([
  event,
  state()
], ElementsDatePicker.prototype, "date", 2);
export {
  DateTimeBehaviorController,
  ElementsDatePicker
};
